export enum CARLINE_BRAND_NDPS {
	VOLKSWAGEN = 'Volkswagen',
	VOLKSWAGEN_COMERCIALES = 'Volkswagen CV',
}

export enum FUEL_TYPE_NDPS {
	COMBUSTION = 'Combustion',
	ELECTRIC = 'Electric',
	HYBRID = 'Hybrid',
	UNDEFINED = 'Undefined',
}

export enum FUEL_TYPE_DATA {
	GASOLINA = 'Gasolina',
	MILD_HYBRID = 'Gasolina mild Hybrid (etiqueta ECO)',
	HIBRIDO = 'Híbrido',
	HIBRIDO_ENCHUFABLE = 'Híbrido enchufable',
	ELECTRICO = 'Eléctrico',
	DIESEL = 'Diésel',
}

export enum MOTORIZACION {
	COMBUSTION = 'combustion',
	HIBRIDO_ENCHUFABLE = 'hibrido_enchufable',
	ELECTRICO = 'electrico',
}

export enum NEW_OR_USED_CAR_NDPS {
	NEW_CAR = 'New Car',
	USED_CAR = 'Used Car',
}

// Claves de mediaAssets candidatas a vista lateral, ordenadas por prioridad.
export const LATERAL_VIEW_MEDIA_KEYS = [
	'Side_Left',
	'D6Turntable3',
	'D6Explore2Alpha',
	'D6Explore1Alpha',
	'D6MOFASideview',
	'D6MOFASideCV',
] as const;
